import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { get } from '../constants';

import ButtonBase from './ButtonBase';

const ButtonOutline = styled(ButtonBase)`
  ${({ color }) => css`
    background-color: transparent;
    color: ${get(`colors.${color}`)};
    border: 1px solid ${get(`colors.${color}`)};

    &:hover {
      background-color: transparent;
      color: ${get(`colors.${color}Dark`)};
      border-color: ${get(`colors.${color}Dark`)};
    }

    &:focus {
      background-color: transparent;
      color: ${get(`colors.${color}Dark`)};
      border-color: ${get(`colors.${color}Dark`)};
    }

    &:active {
      background-color: transparent;
      color: ${get(`colors.${color}Darker`)};
      border-color: ${get(`colors.${color}Darker`)};
    }

    &:disabled {
      background-color: transparent;
      color: ${get(`colors.${color}Light`)};
      border-color: ${get(`colors.${color}Light`)};
      cursor: not-allowed;
    }
  `}
`;

ButtonOutline.propTypes = {
  color: PropTypes.string,
  ...ButtonBase.propTypes,
};

ButtonOutline.defaultProps = {
  color: 'primary',
};

export default ButtonOutline;
